// Where a member lands right after joining a workspace, to set their name and photo.
export const JOIN_PROFILE_PATH = "/welcome/profile"

// Keys, never raw paths, travel through invite links so a crafted link can't redirect off-app.
export const JOIN_NEXT_PATHS = {
	github: "/settings/integrations/github",
} as const

export type JoinNext = keyof typeof JOIN_NEXT_PATHS

export function parseJoinNext(value: unknown): JoinNext | null {
	return typeof value === "string" &&
		Object.prototype.hasOwnProperty.call(JOIN_NEXT_PATHS, value)
		? (value as JoinNext)
		: null
}

export function joinProfilePath(next: JoinNext | null): string {
	return next ? `${JOIN_PROFILE_PATH}?next=${next}` : JOIN_PROFILE_PATH
}

export function joinLandingPath(next: unknown): string {
	const key = parseJoinNext(next)
	return key ? JOIN_NEXT_PATHS[key] : "/threads"
}
